import React, { useEffect, useState, lazy, useRef } from "react";
import "./login.css";
import {
  useLocation,
  useParams,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import MemberLogIn from "./MemberLogIn";

const CustomerLogIn = lazy(() => import("./CustomerLogIn"));

const LogIn = (setLandingData,props) => {
  console.log('setLandingData::: ', setLandingData);
  console.log('props::: ', props);
  let location = useLocation();
  let params = useParams();
  let [searchParams] = useSearchParams();
  const [apiUrl] = useState(
    searchParams.get("domain") === null
      ? "https://" + process.env.REACT_APP_DEFAULT_API_URL
      : searchParams.get("domain")
  );
  const [authkey] = useState(localStorage.getItem("_authkey"));
  const [formId] = useState("5af03fe1dbd19f20e03ac67c");
  const [showIframe, setShowIframe] = useState(false);

  // console.log("search: ", [searchParams]);
  // console.log("params: ", params);
  // console.log("apiUrl: ", apiUrl);
  // console.log("authkey: ", authkey);

  let navigate = useNavigate();
  const [backgroundColor, setbackGroundColor] = useState(null);
  const [foregroundColor, setForeGroundColor] = useState(null);
  const [type, setType] = useState("Member");
  function loadUser(loginid) {
    let obj = { userid: loginid, logintype: type };
    props.loadbuyer(obj);
  }



  let headerImg = [];

  if (
    setLandingData &&
    Array.isArray(setLandingData.headerimg) &&
    setLandingData.headerimg.length > 0
  ) {
    headerImg = setLandingData?.headerimg;
  } else if (setLandingData && setLandingData?.headerimg != null) {
    let obj = { attachment: setLandingData?.headerimg };
    headerImg?.push(obj);
  }



  useEffect(() => {
    const LoadData = () => {
      setColor();
    };
    LoadData();
  }, []);

  const setColor = () => {
    setbackGroundColor(params?.backgroundcolor);
    setForeGroundColor(params?.foregroundcolor);
  };

  const redirectoSignUp = () => {
    navigate(
      "/" +
        localStorage.getItem("CompanyName") +
        (location.pathname.split("/").includes("iframe") ? "/iframe" : "") +
        "/sign-up" +
        (location.pathname.split("/").includes("iframe")
          ? "/" + backgroundColor + "/" + foregroundColor
          : ""),
      {
        state: {
          previouspath: location.state?.previouspath,
          previousdata: location.state?.previousPathState?.selecteddetail,
        },
      }
    );
  };




  console.log('headerImg::: ', headerImg);

  return (
    <>

    <section
      className="common-block bg_img_container_login"
      style={{
        backgroundColor: backgroundColor !== null ? "#" + backgroundColor : "",
        backgroundImage: 'url("/images/bg_img.png")',
        // backgroundImage : headerImg?.length > 0 && headerImg?.[0]?.attachment?.length > 0 ? `url(${headerImg[0]?.attachment})` : "/public/images/bg_login1.png",
      }}
    >

      <div
        className={
          location.pathname.split("/").includes("iframe")
            ? "container-fluid p-0"
            : "container p-0"
        }
      >
        <div className="white-box blur_effect_card middle-box">
          <div className="row">
            <div className="col-12 text-center">
              <h3 className="card-title mb-2 text_title_signin"> Sign In </h3>
            </div>
          </div>
          <div
            className="card-body px-xl-4"
            style={{
              backgroundColor:
                foregroundColor !== null ? "#" + foregroundColor : "",
            }}
          >
            <MemberLogIn  loadBuyer={loadUser} />
          </div>
        </div>
      </div>

    </section>
    </>
  );
};

export default LogIn;
